module.exports = __webpack_public_path__ + "static/2-88fb086ee1461c168683f8b90fad6591.jpeg";